'use client'

import { useTranslations } from 'next-intl'
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion"
import { Card, CardContent } from "@/components/ui/card"
import { Mail, Phone } from 'lucide-react'

export default function TermsAndConditions({ lang }: { lang: string }) {
  const t = useTranslations('terms')

  const sections = [
    'products',
    'pricing',
    'orders',
    'delivery',
    'cancellationAndRefunds',
    'customerCare',
    'intellectualProperty',
    'liability',
    'privacy'
  ]

  return (
    <div className="space-y-8">
      <Accordion type="single" collapsible className="w-full">
        {sections.map((section) => (
          <AccordionItem key={section} value={section}>
            <AccordionTrigger className="text-lg font-semibold text-gray-800">
              {t(`sections.${section}.title`)}
            </AccordionTrigger>
            <AccordionContent>
              <div className="space-y-4 text-gray-600">
                {t(`sections.${section}.content`).split('\n').map((paragraph, index) => (
                  <p key={index}>{paragraph}</p>
                ))}
              </div>
            </AccordionContent>
          </AccordionItem>
        ))}
      </Accordion>

      <Card className="bg-gray-50">
        <CardContent className="pt-6">
          <h2 className="text-xl font-semibold mb-4 text-gray-800">{t('contact.title')}</h2>
          <p className="mb-4 text-gray-600">{t('contact.content')}</p>
          <div className="space-y-2">
            <div className="flex items-center space-x-2 text-gray-600">
              <Mail className="w-5 h-5" />
              <span>{t('contact.email')}:</span>
              <a href="mailto:info@luviflowers.com" className="hover:underline text-[#bcb398] font-roboto">info@luviflowers.com</a>
            </div>
            <div className="flex items-center space-x-2 text-gray-600">
              <Phone className="w-5 h-5" />
              <span>{t('contact.phone')}:</span>
              <a href="tel:+971501489800" className="hover:underline text-[#bcb398] font-roboto">+971 501489800</a>
            </div>
          </div>
        </CardContent>
      </Card>
    </div>
  )
}